import React from 'react';

const BASE = 'inline-flex items-center gap-2 font-medium rounded-lg transition-all duration-150 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-accent/30';

const VARIANTS = {
  primary: 'gold-grad text-on-accent font-bold btn-sheen shadow-[0_6px_20px_-7px_rgba(59,130,246,0.6)] hover:brightness-110 hover:-translate-y-px',
  secondary: 'bg-surface-2 border border-border-2 text-ink hover:bg-surface-3',
  ghost: 'bg-surface border border-border text-ink-2 hover:bg-surface-2 hover:text-ink hover:border-border-2',
  danger: 'bg-transparent border border-red text-red hover:bg-[rgba(239,68,68,.15)]',
};

const SIZES = {
  sm: 'px-2.5 py-1.5 text-xs',
  md: 'px-3.5 py-2 text-sm',
  lg: 'px-5 py-3 text-sm',
  icon: 'w-8 h-8 justify-center p-0 text-sm',
};

export default function Button({ variant = 'ghost', size = 'md', className = '', children, ...props }) {
  return (
    <button
      className={[BASE, VARIANTS[variant], SIZES[size], className].join(' ')}
      {...props}
    >
      {children}
    </button>
  );
}
